<template>
  <v-btn
    color="pwt_palatinate_blue"
    block
    variant="outlined"
    :disabled="disabled"
    :loading="loading"
    class="text-none text-caption px-5"
    :class="{
      'rounded-pill': shape === 'pill',
      'rounded-lg': shape === 'box',
    }"
    @click.stop="emitClick"
  >
    <slot></slot>
  </v-btn>
</template>
<script setup lang="ts">
interface Props {
  loading?: boolean
  disabled?: boolean
  shape?: 'box' | 'pill'
}

const { loading = false, disabled = false, shape = 'pill' } = defineProps<Props>()

const emit = defineEmits(['click'])

function emitClick() {
  emit('click')
}
</script>
